import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";
import 'bootstrap/dist/css/bootstrap.min.css';
import App from "./App";

const store = configureStore({ reducer: rootReducer, devTools: true });

const app = (
  <React.Fragment>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.Fragment>
);

ReactDOM.render(app, document.getElementById("root"));